import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header
      id="header"
      className={`header d-flex align-items-center fixed-top ${
        menuOpen ? "mobile-nav-active" : ""
      }`}
    >
      <div className="container-fluid container-xl position-relative d-flex align-items-center">
        {/* Logo */}
        <Link to="/" className="logo d-flex align-items-center me-auto">
          <h1 className="sitename">MZR Software</h1>
        </Link>

        {/* Navigation */}
        <nav id="navmenu" className="navmenu">
          <ul>
            <li>
              <NavLink to="/" end>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/about">About</NavLink>
            </li>
            <li>
              <NavLink to="/services">Services</NavLink>
            </li>
            <li>
              <NavLink to="/portfolio">Portfolio</NavLink>
            </li>

            <li>
              <NavLink to="/contact">Contact</NavLink>
            </li>
          </ul>

          {/* Mobile Toggle */}
          <i
            className={`mobile-nav-toggle d-xl-none bi ${
              menuOpen ? "bi-x" : "bi-list"
            }`}
            onClick={() => setMenuOpen(!menuOpen)}
          ></i>
        </nav>

        {/* CTA */}
        <Link to="/contact" className="btn-getstarted">
          Get Started
        </Link>
      </div>
    </header>
  );
}
